var _desc, _defs, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "C Star Gradient Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A simple rounded C with a small asterisk star in a vibrant pink to coral gradient.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cGradient",
    x1: 215,
    y1: 780,
    x2: 748,
    y2: 228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F857A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF2F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FF4D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "starGradient",
    x1: 694,
    y1: 450,
    x2: 842,
    y2: 292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F857A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A3D"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 612 300        A 245 245 0 1 0 612 724",
    stroke: "url(#cGradient)",
    strokeWidth: 130,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 604 301        A 245 245 0 1 0 604 723",
    stroke: "url(#cGradient)",
    strokeWidth: 118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.96
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(762 366)",
    fill: "url(#starGradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: -92,
    width: 44,
    height: 184,
    rx: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: -92,
    width: 44,
    height: 184,
    rx: 22,
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: -92,
    width: 44,
    height: 184,
    rx: 22,
    transform: "rotate(-60)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e0fa2e62151fa7ab03e3c64129a52ab2.svg";
export { ForwardRef as ReactComponent };